import { APIRequestStatus } from 'core/constants/redux';
import { IDateRangeTypes, RelativeDateRanges } from 'core/constants/date';
import {
  ArchivalRequestMode, IArchivalExportRow, IArchivalRequestRow, IArchivedRecord,
} from 'core/models/archival';

// What the archival page can show. Driven from the sidebar's Archival tab, so all
// of them share one route (/archival).
export enum ArchivalView {
  Request = 'archival_request',
  Search = 'archival_search',
  Export = 'archival_export',
}

// Record lookup is by namespace + primary key, so it has no period of its own.
export interface IArchivalSearchState {
  namespace: string;
  recordId: string;
}

export interface IArchivalFormState {
  namespace: string;
  // only meaningful for the archival request form
  mode: ArchivalRequestMode;
  // Relative (a duration like "Last 1 year") or Absolute (explicit from/to)
  rangeType: IDateRangeTypes;
  duration: RelativeDateRanges;
  from: string;
  to: string;
}

export enum ArchivalActionTypes {
  SET_ARCHIVAL_VIEW = 'SET_ARCHIVAL_VIEW',
  SET_ARCHIVAL_REQUEST_FORM = 'SET_ARCHIVAL_REQUEST_FORM',
  SET_ARCHIVAL_EXPORT_FORM = 'SET_ARCHIVAL_EXPORT_FORM',
  SET_ARCHIVAL_SEARCH = 'SET_ARCHIVAL_SEARCH',
  RESET_ARCHIVAL_RECORD = 'RESET_ARCHIVAL_RECORD',
  CLEAR_ARCHIVAL_SUBMIT_ERROR = 'CLEAR_ARCHIVAL_SUBMIT_ERROR',
  CREATE_ARCHIVAL_REQUEST = 'CREATE_ARCHIVAL_REQUEST',
  GET_ARCHIVAL_REQUESTS = 'GET_ARCHIVAL_REQUESTS',
  TRIGGER_EXPORT_REQUEST = 'TRIGGER_EXPORT_REQUEST',
  GET_EXPORT_LIST_REQUEST = 'GET_EXPORT_LIST_REQUEST',
  GET_RECORD_REQUEST = 'GET_RECORD_REQUEST',
}

export interface IArchivalRequestProcessing {
  [ArchivalActionTypes.CREATE_ARCHIVAL_REQUEST]: APIRequestStatus;
  [ArchivalActionTypes.GET_ARCHIVAL_REQUESTS]: APIRequestStatus;
  [ArchivalActionTypes.TRIGGER_EXPORT_REQUEST]: APIRequestStatus;
  [ArchivalActionTypes.GET_EXPORT_LIST_REQUEST]: APIRequestStatus;
  [ArchivalActionTypes.GET_RECORD_REQUEST]: APIRequestStatus;
}

export interface IArchivalState {
  requestProcessing: IArchivalRequestProcessing;
  view: ArchivalView;
  requestForm: IArchivalFormState;
  exportForm: IArchivalFormState;
  search: IArchivalSearchState;
  requests: Array<IArchivalRequestRow>;
  exports: Array<IArchivalExportRow>;
  record: IArchivedRecord;
  // the lookup ran but the archive has no such record
  isRecordNotFound: boolean;
  // the lookup route itself is not deployed yet - a different 404 to the above
  isRecordLookupUnavailable: boolean;
  // message from a rejected create - 400 (bad criteria/namespace) or 422
  // (namespace already has a request in flight); shown on the form that raised it
  submitError: string;
}
